import React, { memo } from 'react';

import { log } from '../../../../services/utils';

import { Provider as TagsProvider } from '../../../../contexts/TagsContext';

import TagList from './TagList';

const TagAdmin = () => {
	return (
		<TagsProvider>
			{ log( 'tag administration' ) }
			<TagList />
		</TagsProvider>
	);
};

export default memo( TagAdmin );
